import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Icon from './Icon';
import { NAV } from './siteData';
import { useContact } from './SiteContent';
import T from './components/EditableText';

/** Aus dem Ziel eines Menüpunktes den Textschlüssel machen: `/kosten` → `navigation.kosten`. */
const navKey = (to: string): string => `navigation.${to.replace(/^\//, '')}`;

const SiteHeader: React.FC = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const contact = useContact();

  // Menü schließt sich beim Seitenwechsel
  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-header__logo" aria-label="Zur Startseite">
          <picture>
            {/* 320 px reicht bei einfacher Pixeldichte, die 480er Stufe deckt
                Retina bei 72 px Höhe ab (Breite im Kopf ≈ 172 px, doppelt 344 px). */}
            <source
              type="image/webp"
              srcSet="/website/img/logo-320.webp 320w, /website/img/logo-480.webp 480w"
              sizes="(max-width: 760px) 115px, 172px"
            />
            <img
              src="/website/img/logo.png"
              alt="Seniorenbetreuung Antczak"
              width={572}
              height={240}
            />
          </picture>
        </Link>

        <nav className="site-nav" aria-label="Hauptnavigation">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (isActive ? 'is-active' : undefined)}
            >
              <T k={navKey(item.to)} />
            </NavLink>
          ))}
        </nav>

        <div className="site-header__actions">
          <a href={contact.phoneHref} className="header-phone">
            <span className="dot">
              <Icon name="phone" size={17} />
            </span>
            <span>{contact.phoneLabel}</span>
          </a>
          <Link to="/kontakt" className="btn btn--primary btn--sm">
            <T k="kopf.beratung" />
          </Link>
          <button
            type="button"
            className="burger"
            aria-label={open ? 'Menü schließen' : 'Menü öffnen'}
            aria-expanded={open}
            aria-controls="site-mobile-nav"
            onClick={() => setOpen((v) => !v)}
          >
            <Icon name={open ? 'x' : 'menu'} size={22} />
          </button>
        </div>
      </div>

      {open && (
        <nav id="site-mobile-nav" className="mobile-nav" aria-label="Hauptnavigation (mobil)">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to}>
              <T k={navKey(item.to)} />
            </NavLink>
          ))}
          <NavLink to="/karriere">
            <T k="navigation.karriere" />
          </NavLink>
          <Link to="/kontakt" className="btn btn--primary" style={{ marginTop: 14, width: '100%' }}>
            <T k="kopf.beratung" />
          </Link>
        </nav>
      )}
    </header>
  );
};

export default SiteHeader;
